import type { ReactNode } from 'react'

interface SectionHeaderProps {
  title: string
  description?: string
  /** A trail back up, above the title, on pages below a section. */
  breadcrumb?: ReactNode
  /**
   * Receives the element a section's primary action (Add Language, Generate Code)
   * portals into, so the one thing you can create here always sits on the title row.
   */
  actionSlotRef?: (el: HTMLDivElement | null) => void
  /** The section's primary action, when the page renders it directly rather than through the slot. */
  action?: ReactNode
}

export function SectionHeader({ title, description, breadcrumb, actionSlotRef, action }: SectionHeaderProps) {
  return (
    <header className="mb-8 flex flex-col gap-4 border-b border-border-divider pb-6 sm:flex-row sm:items-start sm:justify-between">
      <div className="min-w-0 max-w-2xl">
        {breadcrumb}
        <h2 id="admin-section-title" className="break-words font-serif text-2xl text-heading">{title}</h2>
        {description && (
          <p className="mt-2 hidden font-serif text-sm leading-relaxed text-muted lg:block">{description}</p>
        )}
      </div>
      <div ref={actionSlotRef} className="shrink-0 empty:hidden">{action}</div>
    </header>
  )
}
